import React from 'react';
import SideMenu from '../sideMenu'; 
import DashboardHeader from '../topbar';
import InfoCard from '../../compopnents/InfoCard'; 
import Styles from "./styles.module.scss";
import Table from '../../compopnents/table/indx';
import { useNavigate } from 'react-router-dom';
import FormHead from '../../compopnents/headings/FromHead';


function UpcomingJoineeTable(props: any) {

    const navigate = useNavigate()


  return (
    <section className="infoCardGrid noHeadCard">
      <InfoCard title="">
        <div className={Styles.infoCardhead}>
        <FormHead>Upcoming joinee's</FormHead>
          <a onClick={() => navigate('/contractresources')}>View All</a>
       </div>
       <div className="dashboardTable">
          <Table type={"upcomingjoinee"} data={props.data} />
        </div>
        </InfoCard>
    </section>
  )
}

export default UpcomingJoineeTable